import { closePopup, showPopup } from './popup'

const initExitPopup = () => {
  const showPopupOnMouseLeave = () => {
    showPopup(exitPopup)
  }
  const closePopupBtn = document.getElementById('close-popup')
  const exitPopup = document.getElementById('exit-popup')
  const popupOverlay = document.getElementById('popup-overlay')
  const closeExitPopup = () => {
    closePopup(exitPopup)
    document.removeEventListener('mouseleave', showPopupOnMouseLeave)
  }

  if (closePopupBtn) {
    closePopupBtn.addEventListener('click', () => {
      closeExitPopup()
    })
  }

  if (popupOverlay) {
    const child = popupOverlay.firstElementChild

    if (child) {
      child.addEventListener('click', function (e) {
        e.stopPropagation()
      })
    }

    popupOverlay.addEventListener('click', () => {
      closeExitPopup()
    })
  }

  const isMobileScreen = window.screen.width <= 1024

  const setExitPopup = () => {
    document.addEventListener('mouseleave', showPopupOnMouseLeave)
  }

  const setMobileExitPopup = () => {
    const showPopupTime = 30000 // 30sec

    const timeoutID = setTimeout(() => {
      showPopup(exitPopup)
      clearTimeout(timeoutID)
    }, showPopupTime)
  }

  if (isMobileScreen) {
    setMobileExitPopup()
  } else {
    setExitPopup()
  }
}

export default initExitPopup
